export default "__VITE_ASSET__CDEs6kKD__"